var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.34 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Applik\\xE1ci\\xF3_let\\xF6lt\\xE9se"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.45,
    y1: 5.72,
    x2: 23.54,
    y2: 5.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.04,
    y1: 56.32,
    x2: 34.34,
    y2: 56.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.01,
    y1: 5.72,
    x2: 12.68,
    y2: 5.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 33.34,
    height: 60,
    rx: 4.49
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "10.29 34.11 17.67 41.49 25.05 34.11"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.67,
    y1: 26.21,
    x2: 17.67,
    y2: 41.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "7.57 40.64 7.57 46.33 27.77 46.33 27.77 40.64"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/downloadWhite.60d013909c9e57bd57f13376427bb294.svg";
export { ForwardRef as ReactComponent };